import Color from 'color';
import { calcAPCA } from 'apca-w3';

function getAccessibleTextColor(backgroundColor: string) {
  const blackL = Math.abs(calcAPCA('#000', backgroundColor));
  const whiteL = Math.abs(calcAPCA('#fff', backgroundColor));
  return blackL > whiteL ? '#000' : '#fff';
}

export default function useColor() {
  const setColors = (primaryColor: string, secondaryColor: string) => {
    const primary = Color(primaryColor);
    const secondary = Color(secondaryColor);
    const docStyle = document.documentElement.style;

    // Set the main Element Plus primary color to the secondary color
    docStyle.setProperty('--el-color-primary', secondary.hex());

    // Generate Element Plus light variants using the built-in mix method
    // Based on Element Plus formula: mix('#FFF', primary, i * 10) where i from 1 to 9
    const white = Color('#FFFFFF');
    for (let i = 1; i <= 9; i++) {
      const mixedColor = secondary.mix(white, i * 0.1); // 0.1 = 10%
      docStyle.setProperty(`--el-color-primary-light-${i}`, mixedColor.hex());
    }

    // Set custom color variables
    docStyle.setProperty('--primary-color', primary.hex());
    docStyle.setProperty('--secondary-color', secondary.hex());

    // Set dark variants
    docStyle.setProperty('--primary-color-dark', primary.darken(0.2).hex());
    docStyle.setProperty('--secondary-color-dark', secondary.darken(0.2).hex());

    // Set accessible text colors
    docStyle.setProperty(
      '--primary-text-color',
      getAccessibleTextColor(primary.hex()),
    );
    docStyle.setProperty(
      '--primary-dark-text-color',
      getAccessibleTextColor(primary.darken(0.2).hex()),
    );
    docStyle.setProperty(
      '--secondary-text-color',
      getAccessibleTextColor(secondary.hex()),
    );
    docStyle.setProperty(
      '--secondary-dark-text-color',
      getAccessibleTextColor(secondary.darken(0.2).hex()),
    );
  };

  return {
    setColors,
  };
}
